import React from "react";
function StoreLocation()
{
    return(
        <>
                {/* <!-- Store locations --> */}
        <section class="flat-spacing-16">
            <div class="container">
                <div class="row widget-tabs">
                    <div class="col-xl-4 col-md-5 col-12">
                        <div class="tf-store-list d-flex gap-10 flex-column widget-menu-tab">
                            <div class="tf-store-item item-title active default">
                                <h6 class="tf-store-title"> ``
                                    <div class="icon">
                                        <i class="icon-place"></i>
                                    </div>
                                    Ecomus Paris
                                </h6>
                                <div class="tf-store-info">
                                    <span>Address</span>
                                    <p>93 Rue du Chevalier de la Barre, 961821 Paris, France</p>
                                </div>
                                <div class="tf-store-info">
                                    <span>Phone</span>
                                    <p>(+33) 936 -1234</p>
                                </div>
                                <div class="tf-store-info">
                                    <span>Email</span>
                                    <p>Ecomus.paris@example.com</p>
                                </div>
                            </div>
                            <div class="tf-store-item item-title default">
                                <h6 class="tf-store-title">
                                    <div class="icon">
                                        <i class="icon-place"></i>
                                    </div>
                                    Ecomus London
                                </h6>
                                <div class="tf-store-info">
                                    <span>Address</span>
                                    <p>Cromwell Rd, South Kensington, London SW1 6BD, UK</p>
                                </div>
                                <div class="tf-store-info">
                                    <span>Phone</span>
                                    <p>(+44) 20 4942 6789</p>
                                </div>
                                <div class="tf-store-info">
                                    <span>Email</span>
                                    <p>Ecomus.london@example.com</p>
                                </div>
                            </div>
                            <div class="tf-store-item item-title default">
                                <h6 class="tf-store-title">
                                    <div class="icon">
                                        <i class="icon-place"></i>
                                    </div>
                                    Ecomus Marid
                                </h6>
                                <div class="tf-store-info">
                                    <span>Address</span>
                                    <p>C. de Ferraz, 1, 150596 Madrid, Spain</p>
                                </div>
                                <div class="tf-store-info">
                                    <span>Phone</span>
                                    <p>(+48) 321-2468</p>
                                </div>
                                <div class="tf-store-info">
                                    <span>Email</span>
                                    <p>Ecomus.marid@example.com</p>
                                </div>
                            </div>
                            <div class="tf-store-item item-title default">
                                <h6 class="tf-store-title">
                                    <div class="icon">
                                        <i class="icon-place"></i>
                                    </div>
                                    Ecomus Tokyo
                                </h6>
                                <div class="tf-store-info">
                                    <span>Address</span>
                                    <p>152-0035 Tokyo, Meguro City, Jiyugaoka, Japan</p>
                                </div>
                                <div class="tf-store-info">
                                    <span>Phone</span>
                                    <p>(623) 934-2400</p>
                                </div>
                                <div class="tf-store-info">
                                    <span>Email</span>
                                    <p>Ecomus.tokyo@example.com</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-8 col-md-7 col-12">
                        <div class="widget-content-tab">
                            <div class="widget-content-inner active p-0">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d158969.55657176184!2d-0.176367!3d51.496715!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760542e6182f3f%3A0x7bb7e385c39764c4!2zQuG6o28gdMOgbmcgTOG7i2NoIHPhu60gVOG7sSBuaGnDqm4gTHXDom4gxJDDtG4!5e0!3m2!1svi!2sus!4v1719308620173!5m2!1svi!2sus" width="100%" height="978"   allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                            <div class="widget-content-inner p-0">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d158969.55657176184!2d-0.176367!3d51.496715!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760542e6182f3f%3A0x7bb7e385c39764c4!2zQuG6o28gdMOgbmcgTOG7i2NoIHPhu60gVOG7sSBuaGnDqm4gTHXDom4gxJDDtG4!5e0!3m2!1svi!2sus!4v1719308885091!5m2!1svi!2sus" width="100%" height="978" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                            <div class="widget-content-inner p-0">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d194388.1638384037!2d-3.717769!3d40.424022!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd42286e8bea1259%3A0x1d6ad9c64a7706ab!2sTemple%20of%20Debod!5e0!3m2!1svi!2sus!4v1719308938883!5m2!1svi!2sus" width="100%" height="978" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                            <div class="widget-content-inner p-0">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d51856.75050320975!2d139.768121!3d35.675847!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x605d1b87f02e57e7%3A0x2e01618b22571b89!2zVMO0a3nDtCwgTmjhuq10IELhuqNu!5e0!3m2!1svi!2sus!4v1719308962873!5m2!1svi!2sus" width="100%" height="978" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <!-- /Store locations --> */}
</>
    )
}
export default StoreLocation;